import { cn } from "@/lib/utils";

interface KpiItem {
  key: string;
  title: string;
  value: number;
  icon: React.ElementType;
  variant: "blue" | "emerald" | "purple" | "destructive" | "amber" | "default";
  loading?: boolean;
}

interface TarefaKpiStripProps {
  items: KpiItem[];
}

// Mesma paleta do NumberKpiCard — mantém os dois exemplares consistentes.
const colorMap: Record<KpiItem["variant"], string> = {
  default: "text-primary bg-primary/10",
  blue: "text-blue-600 bg-blue-500/10 dark:text-blue-400",
  emerald: "text-emerald-600 bg-emerald-500/10 dark:text-emerald-400",
  purple: "text-purple-600 bg-purple-500/10 dark:text-purple-400",
  amber: "text-amber-600 bg-amber-500/10 dark:text-amber-400",
  destructive: "text-red-600 bg-red-500/10 dark:text-red-400",
};

function formatNumber(val: number) {
  return new Intl.NumberFormat("pt-BR").format(val);
}

export function TarefaKpiStrip({ items }: Readonly<TarefaKpiStripProps>) {
  return (
    <div className="overflow-hidden rounded-xl border border-border bg-card shadow-sm">
      <div className="flex divide-x divide-border overflow-x-auto">
        {items.map((item) => (
          <div key={item.key} className="flex min-w-[150px] flex-1 flex-col gap-2 px-4 py-3.5">
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  "flex h-6 w-6 shrink-0 items-center justify-center rounded-md",
                  colorMap[item.variant],
                )}
              >
                <item.icon className="h-3.5 w-3.5" />
              </span>
              <span className="truncate text-xs font-medium text-muted-foreground">
                {item.title}
              </span>
            </div>
            {item.loading ? (
              <div className="h-6 w-12 animate-pulse rounded bg-muted" />
            ) : (
              <span className="font-mono text-xl font-bold tabular-nums tracking-tight text-foreground">
                {formatNumber(item.value)}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export type { KpiItem as TarefaKpiItem };
